var map = {
	"./Airplane.png": 88942,
	"./Almond.png": 57125,
	"./Ankle.png": 15359,
	"./Apple.png": 90286,
	"./Apron.png": 93946,
	"./Arm.png": 9044,
	"./Art.png": 89909,
	"./Baby.png": 30600,
	"./Bag.png": 51344,
	"./Ball.png": 69719,
	"./Balloon.png": 99503,
	"./Bathroom.png": 38554,
	"./Bear.png": 31042,
	"./Bed.png": 45687,
	"./Bee.png": 2670,
	"./Belt.png": 21659,
	"./Bench.png": 61856,
	"./Bicycle.png": 53373,
	"./Bird.png": 96501,
	"./Boat.png": 51042,
	"./Bone.png": 84878,
	"./Book.png": 34075,
	"./Bottle.png": 87552,
	"./Bowl.png": 98908,
	"./Box.png": 63821,
	"./Bracelet.png": 77276,
	"./Brain.png": 3626,
	"./Bread.png": 69612,
	"./Broom.png": 80357,
	"./Bucket.png": 70694,
	"./Cake.png": 36400,
	"./Candy.png": 43329,
	"./Car.png": 70136,
	"./Carrot.png": 57565,
	"./Castle.png": 26256,
	"./Cat.png": 73550,
	"./Chair.png": 59341,
	"./Cheese.png": 4003,
	"./Cherry.png": 7539,
	"./Chicken.png": 22215,
	"./Chocolate.png": 86600,
	"./Clock.png": 83812,
	"./Coffee.png": 59864,
	"./Coin.png": 15983,
	"./Cold.png": 42670,
	"./Cookie.png": 22254,
	"./Couch.png": 22204,
	"./Cow.png": 89835,
	"./Doctor.png": 28429,
	"./Dog.png": 91208,
	"./Doll.png": 36031,
	"./Door.png": 70288,
	"./Dress.png": 42347,
	"./Duck.png": 81419,
	"./Earring.png": 27460,
	"./Egg.png": 61249,
	"./Eight.png": 52531,
	"./Eye.png": 34957,
	"./Face.png": 63663,
	"./Farm.png": 120,
	"./Finger.png": 54047,
	"./Fire.png": 6792,
	"./Fish.png": 96738,
	"./Five.png": 60156,
	"./Flour.png": 64230,
	"./Flower.png": 54521,
	"./Fork.png": 23520,
	"./Four.png": 51084,
	"./Fruit.png": 77328,
	"./Garlic.png": 43238,
	"./Glass.png": 22730,
	"./Glove.png": 88969,
	"./Grape.png": 69435,
	"./Green.png": 4791,
	"./Hand.png": 57283,
	"./Hat.png": 14125,
	"./Head.png": 66442,
	"./Health.png": 89822,
	"./Heart.png": 61138,
	"./Heavy.png": 95643,
	"./Help.png": 87141,
	"./History.png": 45326,
	"./Hook.png": 10037,
	"./Horse.png": 71737,
	"./Hose.png": 20479,
	"./Hospital.png": 43794,
	"./Hot.png": 88095,
	"./House.png": 94514,
	"./Husband.png": 78995,
	"./Jug.png": 60196,
	"./Key.png": 44095,
	"./Kite.png": 1361,
	"./Knife.png": 54405,
	"./Large.png": 48199,
	"./Left.png": 82627,
	"./Leg.png": 18654,
	"./Lemon.png": 39747,
	"./Lentil.png": 67684,
	"./Lion.png": 14574,
	"./Long.png": 62346,
	"./Luggage.png": 80458,
	"./Man.png": 14926,
	"./Mattress.png": 68235,
	"./Milk.png": 44813,
	"./Mirror.png": 71949,
	"./Money.png": 46526,
	"./Monkey.png": 81771,
	"./Month.png": 79068,
	"./Morning.png": 12566,
	"./Mouse.png": 52815,
	"./Mouth.png": 40439,
	"./Mushroom.png": 96630,
	"./Name.png": 63705,
	"./Nest.png": 32682,
	"./Nine.png": 7516,
	"./North.png": 75543,
	"./Nose.png": 80349,
	"./Oat.png": 26506,
	"./Office.png": 28592,
	"./Oil.png": 54554,
	"./One.png": 31910,
	"./Onion.png": 47129,
	"./Oven.png": 21362,
	"./Owl.png": 34548,
	"./Oxygen.png": 78064,
	"./Pants.png": 79240,
	"./Pear.png": 67796,
	"./Pen.png": 67211,
	"./Pencil.png": 41663,
	"./Pepper.png": 71144,
	"./Pig.png": 61190,
	"./Pink.png": 40164,
	"./Plum.png": 32442,
	"./Pool.png": 46610,
	"./Popcorn.png": 51765,
	"./Purple.png": 14334,
	"./Rabbit.png": 22636,
	"./Rag.png": 51104,
	"./Red.png": 3335,
	"./Rice.png": 61275,
	"./Salt.png": 17616,
	"./Sandal.png": 44977,
	"./Scissors.png": 14985,
	"./Scooter.png": 14431,
	"./Seven.png": 91665,
	"./Shampoo.png": 98993,
	"./Sheep.png": 12767,
	"./Shirt.png": 98474,
	"./Shoe.png": 94317,
	"./Short.png": 34652,
	"./Shovel.png": 26849,
	"./Sister.png": 46064,
	"./Six.png": 5034,
	"./Skin.png": 71043,
	"./Small.png": 77951,
	"./Smile.png": 78342,
	"./Snake.png": 13146,
	"./Sock.png": 78908,
	"./Soup.png": 55181,
	"./South.png": 77189,
	"./Spinach.png": 69410,
	"./Spoon.png": 63633,
	"./Strawberry.png": 2135,
	"./Study.png": 24873,
	"./Table.png": 15814,
	"./Taco.png": 28419,
	"./Tea.png": 29472,
	"./Teacher.png": 48100,
	"./Ten.png": 30567,
	"./Three.png": 82266,
	"./Toaster.png": 51254,
	"./Tomato.png": 674,
	"./Tree.png": 83356,
	"./Triangle.png": 97500,
	"./Truck.png": 46867,
	"./Two.png": 31320,
	"./Wallet.png": 14871,
	"./Want.png": 99678,
	"./Water.png": 71491,
	"./Watermelon.png": 41214,
	"./Wheel.png": 57255,
	"./White.png": 15777,
	"./Window.png": 11172,
	"./Yellow.png": 40560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48754;